import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RegionField as RHFRegionField, MultipleRegionFieldProps } from '@anytag/shared-molecules';
import { MarketplaceFormValues, MarketplaceFormKeys } from '../types';

export const RegionField = (
  props: Omit<MultipleRegionFieldProps<MarketplaceFormKeys>, 'name' | 'multiple' | 'countryId'>
) => {
  const { t } = useTranslation();
  const { watch } = useFormContext<MarketplaceFormValues>();
  const countryIdValue = watch(MarketplaceFormKeys.countryId);

  const isIndonesiaCountry = countryIdValue === 'ID';

  return (
    <RHFRegionField
      countryId={countryIdValue}
      name={MarketplaceFormKeys.regionIds}
      title={t(isIndonesiaCountry ? 'Selector.City' : 'Selector.Region')}
      help={t(isIndonesiaCountry ? 'Tooltip.Marketplace City' : 'Tooltip.Marketplace Region')}
      multiple
      {...props}
    />
  );
};
